﻿import { logException }  from "@nephele/error-logger";

logError = function logError(err) {
  logException(err);
}